<template>
    <div class="businessMessage">
        <div class="searchForm">
            <el-form ref="form" :model="form" label-width="70px" @submit.native.prevent>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="查询条件">
                            <el-input v-model="form.searchParam" autocomplete="off" placeholder="id/标题/发送系统/接收系统/接收人"
                                      style="width: 300px"
                                      @keyup.enter.native="getMessageList(1)"/>
                        </el-form-item>
                        <el-button type="primary" style="margin-left: 20px;" @click="getMessageList(1)">查询</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="dataBox">
            <el-table v-loading="loading" element-loading-text="数据加载中" :data="tableData" stripe>
                <el-table-column type="expand">
                    <template slot-scope="scope">
                        <el-form label-position="left" class="table-expand">
                            <el-form-item>
                                <el-row>
                                    <el-col :span="2" class="expandLabel">内容</el-col>
                                    <el-col :span="21" class="expandContent">{{ scope.row.content }}</el-col>
                                </el-row>
                            </el-form-item>
                            <el-form-item>
                                <el-row>
                                    <el-col :span="2" class="expandLabel">跳转链接</el-col>
                                    <el-col :span="21" class="expandContent">{{ scope.row.url }}</el-col>
                                </el-row>
                            </el-form-item>
                            <el-form-item>
                                <el-row>
                                    <el-col :span="2" class="expandLabel">过期时间</el-col>
                                    <el-col :span="21" class="expandContent">{{ parseTime(scope.row.expireTime) }}</el-col>
                                </el-row>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="消息id"/>
                <el-table-column prop="businessMsgType" label="消息类型">
                    <template slot-scope="scope">
                        <span>{{ parseType(scope.row.businessMsgType) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="title" show-overflow-tooltip label="标题"/>
                <el-table-column prop="sourceSystem" label="发送系统"/>
                <el-table-column prop="targetSystem" label="接收系统"/>
                <el-table-column prop="adAccount" label="接收人"/>
                <el-table-column prop="sendTime" sortable label="发送时间">
                    <template slot-scope="scope">
                        <span>{{ parseTime(scope.row.sendTime) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="140">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status === 1 ? 'warning' :scope.row.status===2 ? 'success':'info'">{{
                            parseStatus(scope.row.status) }}
                        </el-tag>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    :page-sizes="[10,20,50]"
                    :page-size="pageSize"
                    :current-page.sync="pageNum"
                    @size-change="sizeChangeClick"
                    @current-change="currChangeClick"
                    @prev-click="prevClick"
                    @next-click="nextClick"
            />
        </div>
    </div>
</template>

<script>
    import {parseTime} from "@/util/index";
    import httpUrl from "@/static/configUrl";

    export default {
        name: "business",
        components: {},
        data() {
            return {
                // clientId: this.$store.state.request.appId,
                form: {
                    searchParam: '',
                    type: 4
                },
                tableData: [],
                total: 0,
                pageNum: 1,
                pageSize: 10,
                loading: false,
                dialogEditFormVisible: false,
                dialogFormVisible: false,
            }
        },
        computed: {
            clientId(){
                return this.$store.state.request.appId
            }
        },
        watch:{
            clientId() {
                this.getMessageList()
            }
        },
        created() {
            this.getMessageList()
        },
        mounted() {
        },
        methods: {
            parseTime,
            parseType(type) {
                switch (type) {
                    case 1:
                        return "公告"
                    case 2:
                        return "通知"
                    default:
                        return "未知消息类型"
                }
            },
            parseStatus(status) {
                switch (status) {
                    case 1:
                        return "消息未读"
                    case 2:
                        return "消息已读"
                    case 3:
                        return "消息过期"
                    default:
                        return "未知状态"
                }
            },
            getMessageList(_pageNum) {
                const that = this
                if (_pageNum === 1) {
                    that.pageNum = 1
                }
                that.loading = true
                const _data = {
                    curl: httpUrl.messageUrl + '/message/list',
                    clientId: that.clientId,
                    searchParam: that.form.searchParam,
                    type: that.form.type,
                    page: that.pageNum,
                    size: that.pageSize
                }
                that.$store.dispatch('httpPost', _data).then(function (res) {
                    that.tableData = res.data.content
                    that.total = parseInt(res.data.total)
                    that.loading = false
                }, function (err) {
                    console.log(err.message)
                    that.loading = false
                })
            },
            // 分页 每页条数改变
            sizeChangeClick(val) {
                this.pageSize = val
                this.getMessageList()
            },
            // 分页 改变当前页
            currChangeClick(val) {
                this.pageNum = val
                this.getMessageList()
            },
            // 分页 上一页
            prevClick(val) {
                this.pageNum = val
                this.getMessageList()
            },
            // 分页 下一页
            nextClick(val) {
                this.pageNum = val
                this.getMessageList()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .businessMessage {
        .searchForm {
            /*background: #fff;*/
            /*height: 45px;*/
            /*padding-top: 10px;*/
            padding-left: 10px;
            .el-input {
                width: 200px;
            }
        }


    }
</style>
<style>
    .businessMessage .searchForm .el-form-item {
        display: inline-block;
    }

    .businessMessage .searchForm .el-form-item:nth-child(2) {
        margin-left: 30px;
    }

    .businessMessage .table-expand {
        font-size: 0;
    }

    .businessMessage .table-expand .expandLabel {
        width: 90px;
        color: #99a9bf;
    }

    .businessMessage .table-expand .expandContent {
        word-break: break-all;
    }

    .businessMessage .table-expand .el-form-item {
        margin-left: 50px;
        margin-right: 0;
        margin-bottom: 0;
        width: 100%;
    }
</style>
